import { Eye, X } from 'lucide-react'
import {
  getImpersonatedLabel,
  isImpersonating,
  clearImpersonation,
} from '@/lib/impersonation'

/**
 * Sticky banner shown whenever a staff member is viewing the app "as" another
 * user. Makes the impersonation impossible to forget and gives a one-click
 * exit back to the admin console. Renders nothing when not impersonating.
 */
export function ImpersonationBanner() {
  if (!isImpersonating()) return null
  const label = getImpersonatedLabel()

  function exit() {
    clearImpersonation()
    // Hard navigate back to the admin console; full reload clears every
    // react-query cache so the app re-renders as the real staff user.
    window.location.href = '/super-admin'
  }

  return (
    <div className="flex items-center justify-between gap-3 border-b border-amber-500/30 bg-amber-500/15 px-4 py-1.5">
      <div className="flex items-center gap-2 text-xs font-medium text-amber-200">
        <Eye className="h-3.5 w-3.5" />
        <span>
          Viewing as <span className="font-semibold">{label ?? 'another user'}</span> — actions you
          take affect their account.
        </span>
      </div>
      <button
        onClick={exit}
        className="flex items-center gap-1 rounded-md border border-amber-400/40 px-2 py-0.5 text-xs font-semibold text-amber-100 transition-colors hover:bg-amber-500/20"
      >
        <X className="h-3 w-3" />
        Exit
      </button>
    </div>
  )
}
